export interface Office {
  code: string;
  name: string;
  contact: string;
}

export const HeadOfficeCode: string = '00';
